import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './editorStyles.css';
import About from './pages/About';
import Index from './pages/Index';
import ForumModes_chatroom from './pages/ForumMode/ForumChatRoom.js';
import ForumModes_sticker from './pages/ForumMode/ForumSticker.js';
import TagBasedForum from './pages/ForumMode/TagBasedForum.js';
import Dashboard from './pages/Dashboard';
import { ModeProvider } from './contexts/ModeContext';
import { AuthProvider } from './contexts/AuthContext';
import React from 'react';
import Main from './pages/main';
import Settings from './pages/Settings';
import Homepage from './pages/Homepage/Homepage';
import JoinStudentClass from './pages/JoinStudentClass';
import { STUDENT_CLASS_JOIN_ROUTE } from './utils/studentClassRoutes';
import { HomeRedirect, ProtectedRoute } from './components/AuthRedirects';
import GlobalToastContainer from './components/GlobalToastContainer';
// 訪客模式組件
import GuestChatRoom from './pages/GuestMode/GuestChatRoom';
import GuestSticker from './pages/GuestMode/GuestSticker';
import GuestTaggedForum from './pages/GuestMode/GuestTaggedForum';
import GuestStickerWorkspace from './pages/GuestMode/GuestStickerWorkspace';

export default function App() {
  return (
    <AuthProvider>
      <ModeProvider>
        <Router className="App">
          <Routes>
            <Route path='/' element={<HomeRedirect/>}></Route>
            <Route path='/about' element={<About/>}></Route>
            
            {/* 訪客模式路由 - 不需要認證 */}
            <Route path='/guest/:activityId/:groupId/chatroom' element={<GuestChatRoom/>}></Route>
            <Route path='/guest/:activityId/:groupId/sticker' element={<GuestSticker/>}></Route>
            <Route path='/guest/:activityId/:groupId/tagged-forum' element={<GuestTaggedForum/>}></Route>
            <Route path='/guest/:activityId/:groupId/workspace' element={<GuestStickerWorkspace/>}></Route>
            
            <Route path='/home' element={
              <ProtectedRoute>
                <Index/>
              </ProtectedRoute>
            }></Route>
            <Route path='/dashboard' element={
              <ProtectedRoute>
                <Dashboard/>
              </ProtectedRoute>
            }></Route>
            <Route path='/main' element={
              <ProtectedRoute>
                <Main/>
              </ProtectedRoute>
            }></Route>
            <Route path='/settings' element={
              <ProtectedRoute>
                <Settings/>
              </ProtectedRoute>
            }></Route>
            <Route path='/homepage' element={
              <ProtectedRoute>
                <Homepage/>
              </ProtectedRoute>
            }></Route>
            <Route path={STUDENT_CLASS_JOIN_ROUTE} element={<JoinStudentClass/>}></Route>
            <Route path='/forum/modes/chatroom' element={
              <ProtectedRoute>
                <ForumModes_chatroom/>
              </ProtectedRoute>
            }></Route>
            <Route path='/forum/modes/sticker' element={
              <ProtectedRoute>
                <ForumModes_sticker/>
              </ProtectedRoute>
            }></Route>
            <Route path='/forum/modes/tagged-forum' element={
              <ProtectedRoute>
                <TagBasedForum/>
              </ProtectedRoute>
            }></Route>
          </Routes>
          {/* 全局 Toast 通知容器 */}
          <GlobalToastContainer />
        </Router>
      </ModeProvider>
    </AuthProvider>
  );
}